const binding = { modules: {}, dataActions: {} };

    (binding.modules['szf-map'] = {
        c: () => require('partner/modules/szf-map/szf-map.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'szf-map',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/szf-map'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|szf-map|szf-map'] = {
                c: () => require('partner/modules/szf-map/szf-map.view.tsx'),
                cn: '__local__-__local__-szf-map'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };